import { FC } from "react";
import { ROUTES } from "constants/routes";
import { SignUp } from "features/SignUp";
import { AuthLayout } from "layouts/AuthLayout";

const SignUpPage: FC = () => (
  <AuthLayout backRoute={ROUTES.signIn} centered={false}>
    <SignUp />
  </AuthLayout>
);

export default SignUpPage;
